import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ILoadBulkImportEmployeesResponse } from '../models/bulk-import-employees.model';

export const sendSelectedEmployeeInviteKey = 'sendSelectedEmployeeInvite';

export interface SendSelectedEmployeeInviteState {
  sendSelectedEmployeeInviteResponse: any;
  sendSelectedEmployeeInviteFailure: any;
  loaded: boolean;
}

export const initialState: SendSelectedEmployeeInviteState = {
  sendSelectedEmployeeInviteResponse: undefined,
  sendSelectedEmployeeInviteFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.sendSelectedEmployeeInvitationsSuccess, (state, action) => ({
    ...state,
    sendSelectedEmployeeInviteResponse: action.response,
    loaded: true
  })),

  on(actions.sendSelectedEmployeeInvitationsFailure, (state, action) => ({
    ...state,
    sendSelectedEmployeeInviteFailure: action.error
  }))
);

export const sendSelectedEmployeeInvite = (state: SendSelectedEmployeeInviteState) => state.sendSelectedEmployeeInviteResponse;
